export enum GameStatus {
  Ready = 0,
  Processing = 1,
  Processed = 2,
}
